import * as firebase from 'firebase';

const prodConfig = {
  apiKey: "AIzaSyCKYbroZpSTkQ2UkRvR4zvQWep5Mh-eMlU",
  authDomain: "engelsoft-hotspot.firebaseapp.com",
  databaseURL: "https://engelsoft-hotspot.firebaseio.com",
  projectId: "engelsoft-hotspot",
  storageBucket: "engelsoft-hotspot.appspot.com",
  messagingSenderId: "954094804919"
};

const devConfig = {
  apiKey: "AIzaSyCKYbroZpSTkQ2UkRvR4zvQWep5Mh-eMlU",
  authDomain: "engelsoft-hotspot.firebaseapp.com",
  databaseURL: "https://engelsoft-hotspot.firebaseio.com",
  projectId: "engelsoft-hotspot",
  storageBucket: "engelsoft-hotspot.appspot.com",
  messagingSenderId: "954094804919"
};

const config = process.env.NODE_ENV === 'production'
  ? prodConfig
  : devConfig;


if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const db = firebase.database();
const auth = firebase.auth();

// Sign Facebook In
export const FacebookProvide = () => {
  return new firebase.auth.FacebookAuthProvider();
  //provide.addScope('user_birthday');
}

export {
   db,
   auth   
};



// WEBPACK FOOTER //
// ./src/firebase/firebase.js